var map = {
	"./analysis.isvg": "84b2",
	"./analytics-1.isvg": "0e38",
	"./analytics.isvg": "be72",
	"./antiseptic.isvg": "1713",
	"./baby.isvg": "e772",
	"./bacteria.isvg": "31a1",
	"./bar.isvg": "3cb0",
	"./barsplit.isvg": "df28",
	"./blood.isvg": "f93e",
	"./boxplot.isvg": "453f",
	"./calendar.isvg": "fada",
	"./cannula.isvg": "886a",
	"./car.isvg": "bfe8",
	"./catheter-prolong.isvg": "2d59",
	"./catheter-uri.isvg": "543c",
	"./chamber.isvg": "6e3c",
	"./chart.isvg": "7b08",
	"./chisquare.isvg": "d6e9",
	"./clipboard.isvg": "bfa5",
	"./comparison.isvg": "b2f5",
	"./csv-1.isvg": "9821",
	"./csv.isvg": "4332",
	"./datadock.isvg": "930e",
	"./dictionary.isvg": "835c",
	"./doctor.isvg": "6bb4",
	"./doughnut.isvg": "6506",
	"./dropper.isvg": "3011",
	"./event.isvg": "8b6e",
	"./file-1.isvg": "e95f",
	"./file.isvg": "34b0",
	"./files.isvg": "7fe0",
	"./flow-chart.isvg": "09c3",
	"./folder.isvg": "a8ce",
	"./form.isvg": "3921",
	"./guide.isvg": "f863",
	"./hospital-1.isvg": "c214",
	"./hospital.isvg": "1677",
	"./human-lungs.isvg": "ed1d",
	"./id.isvg": "7a1d",
	"./indicator-bar.isvg": "b625",
	"./laboratory.isvg": "a5ea",
	"./list.isvg": "94b1",
	"./lungs.isvg": "14cd",
	"./map.isvg": "accf",
	"./medical-history-1.isvg": "67e4",
	"./medical-history.isvg": "eb07",
	"./medical-report.isvg": "c7d3",
	"./mother.isvg": "0315",
	"./name.isvg": "1ade",
	"./newborn.isvg": "3b90",
	"./notebook.isvg": "abff",
	"./open-box.isvg": "677d",
	"./oxygen-1.isvg": "46e3",
	"./oxygen-mask.isvg": "82d1",
	"./oxygen.isvg": "6336",
	"./pbar.isvg": "654f",
	"./pbarsplit.isvg": "0093",
	"./pdf.isvg": "0f85",
	"./petri-dish.isvg": "4366",
	"./pipe.isvg": "3f10",
	"./plaster.isvg": "8aa4",
	"./polar.isvg": "3018",
	"./poster.isvg": "814d",
	"./presentation.isvg": "2e36",
	"./registration.isvg": "81cc",
	"./repair.isvg": "561c",
	"./sanitizer.isvg": "c976",
	"./schedule.isvg": "2c80",
	"./scoreboard.isvg": "9710",
	"./siphon.isvg": "3def",
	"./speaker.isvg": "e21e",
	"./stethoscope.isvg": "c137",
	"./swabs.isvg": "0096",
	"./upload.isvg": "1183",
	"./violin.isvg": "2644",
	"./youtube.isvg": "d8b1"
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(__webpack_require__);
}
function webpackAsyncContextResolve(req) {
	return Promise.resolve(/* lazy-once context */).then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = "bc8d";
module.exports = webpackAsyncContext;